import React from 'react'
import styled from 'styled-components'
import { CardElement, injectStripe } from 'react-stripe-elements'
import { Button } from '../common/Button'

const StripeCheckoutForm = (props: any) => {
  async function handleSubmit(e: any) {
    console.log(e)
    let { token } = await props.stripe.createToken({ name: props.me.user.name })

    if (!token) {
      alert(props.catalogue.creditSettlement.failedReadCardInfo)
      return
    }

    if (props.onAction) {
      props.onAction(token.id)
    }
  }
  return (
    <div>
      <StyledCardElement hidePostalCode={true} />
      <Button look={'primary'} style={{ marginTop: '12px' }} onClick={handleSubmit}>
        {props.catalogue.title}
      </Button>
    </div>
  )
}

const StyledCardElement = styled(CardElement)`
  border: solid 1px #cccccc;
  padding: 3px;
`

export default injectStripe(StripeCheckoutForm)
